import "./style.css"; 
import { useState } from "react";
import { ThemeProvider } from '@mui/material/styles';
import { createTheme } from '@mui/material/styles';
import face from "../../Images/icons/face.png";
import whats from "../../Images/icons/whats.png";
import insta from "../../Images/icons/insta.png";
import tik from "../../Images/icons/tik.png";
import snap from "../../Images/icons/snap.png";
export default function Footer() {
  const [isOpen, setIsOpen] = useState(false);
  const toggleMenu = () => {
     
    setIsOpen(!isOpen);
  };
    const [activeLink, setActiveLink] = useState("home");
   
    const handleLinkClick = (link) => {
      setActiveLink(link);
      setIsOpen(false);
    };
  const theme = createTheme({
    palette: {
      primary: {
         
              main: '#FFCD00',
              dark: '#ffcd38',
              contrastText: '#000',
        
      },
    },
  });
  return (
    <ThemeProvider theme={theme}>
    <div className="footer">
     
    <div className="footer">
        <h3 style={{ color: "#FFF0FB" }}> تواصل معنا</h3>
        <div className="socialFoot">
          <a
            href="https://www.instagram.com/spamanarea/"
            target="_blank"
            rel="noreferrer"
          >
            <img src={insta} alt="insta" className="socialIcon" />
          </a>
          <a
            href="https://www.facebook.com/profile.php?id=61571041986973"
            target="_blank"
            rel="noreferrer"
          >
            <img src={face} alt="facebook" className="socialIcon" />
          </a>
          <a
            href="https://www.tiktok.com/@spamanarea"
            target="_blank"
            rel="noreferrer"
          >
            <img src={tik} alt="tik" className="socialIcon" />
          </a>
          <a
            href="https://snapchat.com/t/flaOPhit"
            target="_blank"
            rel="noreferrer"
          >
            <img src={snap} alt="snap" className="socialIcon" />
          </a>
          <a
            href="whatsapp://send?phone=+966550769152"
            target="_blank"
            rel="noreferrer"
          >
            <img src={whats} alt="whats" className="socialIcon" />
          </a>
        </div>
        <div className="footerNav" id="تواصل معنا">
          <ol className="linkListFoot">
          
            <li>
              <a
                href="/الخدمات"
                className={
                  activeLink === "الخدمات"
                    ? "navLinkFoot active"
                    : "navLinkFoot"
                }
                onClick={() => handleLinkClick("الخدمات")}
              >
                الخدمات
              </a>
            </li>
        
            <li>
              <a
                className={
                  activeLink === "معرض الصور"
                    ? "navLinkFoot active"
                    : "navLinkFoot"
                }
                onClick={() => handleLinkClick("معرض الصور")}
                href="/معرض الصور"
              >
                معرض الصور
              </a>
            </li>
          </ol>
        </div>
        <div  className="footerCopyRight">
          <span style={{ color: "#fff", fontWeight: "bolder" }}>
            {" "}
            Powered   <a
                className="navLinkFoot"
                href="https://h4c.pro/"
              > by H4C </a> مركز سبأ منطقة الرجل | حقوق النشر © 2025 جميع الحقوق محفوظة
          </span>
        </div>
      </div>
    
    </div>
    </ThemeProvider>
  );
}
